export default {
  state: {
    auth: {},
  },
  getters: {
    email: (state: any) => {
      return state.auth.email || '';
    },
    userName: (state: any) => {
      return state.auth.userName || '';
    },
    tel: (state: any) => {
      return state.auth.tel || '';
    },
    authority: (state: any) => {
      return state.auth.authority || [];
    },
    spaceSettingAuthority: (_state: any, getters: any) => {
      return getters.authority.includes('SPACE_SETTING');
    },
    spaceOwnerAuthority: (_state: any, getters: any) => {
      return getters.authority.includes('SPACE_OWNER');
    },
    userControlAuthority: (_state: any, getters: any) => {
      return getters.authority.includes('USER_CONTROL');
    },
    resourceAuthority: (_state: any, getters: any) => {
      return getters.authority.includes('RESOURCE');
    },
    localPaymentAuthority: (_state: any, getters: any) => {
      return getters.authority.includes('LOCAL_PAYMENT');
    },
    couponAuthority: (_state: any, getters: any) => {
      return getters.authority.includes('COUPON');
    },
    membershipAuthority: (_state: any, getters: any) => {
      return getters.authority.includes('MEMBERSHIP');
    },
  },
  mutations: {
    updateAuth: (state: any, res: any) => {
      state.auth = res || {};
    },
  },
};
